import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import InputForm from './InputForm';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import PickerSelect from './PickerSelect';
import { hasRegisteredStates, getStates } from '../utils/country.utils';
import { Checkbox } from './Checkbox';
import BaseText from './BaseText';

export default function FrontierFlightReimbursmentForm({
  formikProps,
  countryList,
  isCheckboxCheckedFunc,
  setSelectedCountry,
}) {
  const namespace = 'air';
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('PurchaseCreditCard');
  const [stateList, setStateList] = useState([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const fillStates = async (_countryCode, formikProps) => {
    if (hasRegisteredStates(_countryCode)) {
      const res = await getStates(_countryCode);
      formikProps.setFieldValue(namespace + '.ccStateList', res);
      setStateList(res);
    }
  };

  return (
    <View>
      <View style={styles.checkboxContainer}>
        <Checkbox
          style={styles.checkboxStyle}
          selected={isCheckboxChecked}
          onPress={() => {
            setIsCheckboxChecked(!isCheckboxChecked);
            isCheckboxCheckedFunc(!isCheckboxChecked);
          }}
        />
        <BaseText style={styles.sameAddressMsg}>
          My credit card address is the same address that I would like to use to receive my Frontier
          flight reimbursment check.
        </BaseText>
      </View>
      <InputForm
        value={
          isCheckboxChecked
            ? formikProps?.values[namespace]['ccBillingAddress']
            : formikProps?.values[namespace]['ccBillingAddressFrontier']
        }
        onChangeText={formikProps?.handleChange(namespace + '.ccBillingAddressFrontier')}
        placeholder={t(tKey('EnterBillingAddress'))}
        errorMessage={
          formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccBillingAddressFrontier
        }
      />
      <InputForm
        value={
          isCheckboxChecked
            ? formikProps?.values[namespace]['ccCity']
            : formikProps?.values[namespace]['ccCityFrontier']
        }
        onChangeText={formikProps?.handleChange(namespace + '.ccCityFrontier')}
        placeholder={t(tKey('EnterCity'))}
        errorMessage={
          formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccCityFrontier
        }
      />
      <PickerSelect
        onValueChange={(value) => {
          setSelectedCountry(value);
          formikProps?.setFieldValue(namespace + '.ccStateFrontier', '');
          formikProps?.setFieldValue(namespace + '.ccCountryFrontier', value);
          fillStates(value, formikProps);
        }}
        items={countryList}
        value={
          isCheckboxChecked
            ? formikProps?.values[namespace]['ccCountry']
            : formikProps?.values[namespace]['ccCountryFrontier']
        }
        placeholder={{ label: t(tKey('SelectCountry')) }}
        errorMessage={
          formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccCountryFrontier
        }
      />
      {hasRegisteredStates(formikProps?.values[namespace]['ccCountryFrontier']) ? (
        <>
          <PickerSelect
            onValueChange={(value) => {
              formikProps?.setFieldValue(namespace + '.ccStateFrontier', value);
              formikProps?.setFieldValue(namespace + '.ccZipCodeFrontier', '');
            }}
            items={stateList}
            value={
              isCheckboxChecked
                ? formikProps?.values[namespace]['ccState']
                : formikProps?.values[namespace]['ccStateFrontier']
            }
            placeholder={{ label: t(tKey('SelectState')) }}
            errorMessage={
              formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccStateFrontier
            }
          />
        </>
      ) : (
        <InputForm
          value={
            isCheckboxChecked
              ? formikProps?.values[namespace]['ccState']
              : formikProps?.values[namespace]['ccStateFrontier']
          }
          onChangeText={formikProps?.handleChange(namespace + '.ccStateFrontier')}
          placeholder={t(tKey('EnterState'))}
          errorMessage={
            formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccStateFrontier
          }
        />
      )}
      <InputForm
        value={
          isCheckboxChecked
            ? formikProps?.values[namespace]['ccZipCode']
            : formikProps?.values[namespace]['ccZipCodeFrontier']
        }
        onChangeText={formikProps?.handleChange(namespace + '.ccZipCodeFrontier')}
        placeholder={t(tKey('EnterZipCode'))}
        errorMessage={
          formikProps?.submitCount > 0 && formikProps?.errors[namespace]?.ccZipCodeFrontier
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  sameAddressMsg: {
    fontWeight: '600',
    marginLeft: 10,
    marginBottom: 8,
  },
  checkboxContainer: {
    width: '85%',
    flexDirection: 'row',
    paddingLeft: 10,
    justifyContent: 'space-between',
  },
  checkboxStyle: {
    marginTop: 10,
  },
});
